"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locales = void 0;
const locales = exports.locales = {
  en: "en",
  es: "es",
  fr: "fr",
  pt: "pt",
  zh: "zh",
  de: "de",
  it: "it",
  ja: "ja",
  tl: "tl",
  hi: "hi",
  ko: "ko"
};